import { getCookie } from "./Cookie";
import CryptoJS from 'crypto-js';

export function getUserRole() {
    const authData = getCookie('token')
    const decrypted = CryptoJS.AES.decrypt(authData, 'P@ssw0rd').toString(CryptoJS.enc.Utf8);
    if (authData != '') {
        return JSON.parse(decrypted).role
    } else return '';
}